import { IsObject, IsOptional, IsString, ValidateNested, IsBoolean } from 'class-validator';
import { Type } from 'class-transformer';
import { LayerTextDto } from './layer-text.dto';
import { AssetDto } from '../../../asset/models/asset.dto';
import { LayerVideoDto } from './layer-video.dto';
import { LayerOptimizationsDto } from './layer-optimization.dto';
import { MergeTagDto } from "../merge-tag/merge-tag.dto";
import { InteractivityDto } from '../interactivity.dto';

export class CustomizationOptionLayerDto {
	@IsString()
	id: string;

	@IsString()
	@IsOptional()
	label: string;

	@IsOptional()
	@ValidateNested()
	@Type(() => LayerTextDto)
	text?: LayerTextDto;

	@IsOptional()
	image?: AssetDto;

	@IsOptional()
	@ValidateNested()
	@Type(() => LayerVideoDto)
	video?: LayerVideoDto;

	@IsOptional()
	@IsString()
	assetPath?: string;

	@IsOptional()
	style?: any;

	@IsOptional()
	optimizations?: LayerOptimizationsDto;

	@IsOptional()
	previewOptimizations?: LayerOptimizationsDto;

	@IsOptional()
	@ValidateNested()
	@Type(() => InteractivityDto)
	interactivity?: InteractivityDto;

	@IsOptional()
	@IsObject()
	mergeTags?: Record<string, MergeTagDto[]>;

	@IsOptional()
	@IsBoolean()
	hidden?: boolean;
}
